import { useSelector } from "@redux";
import RestEdit from 'containers/rest/Edit';
import { DynamicObjectType } from "types/commons";
import Form from "../components/RelatedSKUsForm";

export default function RelatedSKUsEdit() {
   const variantRelatedCurr = useSelector((state) => state.variantRelated.currentData) as DynamicObjectType;

   const breadcrumbs = [
      {
         title: 'common.page.settings',
         href: '/settings',
       },
       {
          title: 'common.page.variantRelated',
          href: '/settings/manage-related-skus',
       },
      {
        title: `#${variantRelatedCurr?.id}`,
      },
   ];

   const handleDataConvert = (record) => {      
      const convertBulk = record?.productVariantRelateds?.slice(1)?.map((item) => ({
         relatedVariantSku: item?.relatedVariantSku,
         priority: item?.priority
      }));

      return ({
         originalVariantSku: record?.productVariantRelateds?.[0]?.originalVariantSku,
         originalPriority: record?.productVariantRelateds?.[0]?.priority,
         productVariantRelateds: convertBulk
      })
   }
   
   return (
      <>
         <RestEdit
            model="variantRelated"
            breadcrumbs={breadcrumbs}
            customUrlBack="/settings/manage-related-skus"
            apiOptions={{
               // suffix: '/bulk',
               isRequestApi: true,
            }}
            formatOnSubmit={(value) => {
               const convertData = value?.productVariantRelateds?.map((item) => ({
                  originalVariantSku: value?.originalVariantSku,
                  relatedVariantSku: item?.relatedVariantSku,
                  relatedVariantId: variantRelatedCurr?.id,
                  priority: item?.priority
               })) || [];
               
               return ({
                  id: variantRelatedCurr?.id,
                  productVariantRelateds: [
                     {
                        originalVariantSku: value?.originalVariantSku,
                        relatedVariantSku: value?.originalVariantSku,
                        relatedVariantId: variantRelatedCurr?.id,
                        priority: value?.originalPriority,
                     },
                     ...convertData,
                  ]
               })
            }}
             handleDataConvert={handleDataConvert}
         >
            <Form />
         </RestEdit>
      </>
   )
}